enum ZipCodeUpdateEventSource {
  CartSummary = 'cart-summary',
  GlobalHeader = 'global-header',
  AdditionalServices = 'additional-services',
}

export interface ZipCodeUpdateEvent {
  zipCode: string;
  source?: ZipCodeUpdateEventSource;
}

export { ZipCodeUpdateEventSource as ZipCodeFormPlacement };
